export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COUNTRIES_START = "FETCH_COUNTRIES_START";
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR';

export const FETCH_COUNTRY_STATES = 'FETCH_COUNTRY_STATES';
export const FETCH_COUNTRY_STATES_START = "FETCH_COUNTRY_STATES_START";
export const FETCH_COUNTRY_STATES_SUCCESS = 'FETCH_COUNTRY_STATES_SUCCESS';
export const FETCH_COUNTRY_STATES_ERROR = 'FETCH_COUNTRY_STATES_ERROR';

export const fetchCountries = () => {
    return {
        type: FETCH_COUNTRIES,
    };
}

export const fetchCountryStates = (countryId) => {
    return {
        type: FETCH_COUNTRY_STATES,
        payload: countryId
    };
}